import type {DistributorItem} from './distributor-find';

export type DistributorType = 'shop' | 'workshop' | 'workshop24'

const isInPartsDealerMode = (): boolean => {
  const typeFilterElement = document.getElementById('distributor-search-filter__type')

  if (!(typeFilterElement instanceof HTMLSelectElement) && !(typeFilterElement instanceof HTMLInputElement)) {
    throw new Error('Could not find Distributor Type Filter Element')
  }

  return typeFilterElement.value === 'Partsdealer'
}

/**
 * Return the Type of the Distributor Item.
 */
export const detectDistributorType = (distributor: DistributorItem): DistributorType => {
  if (isInPartsDealerMode()) {
    return 'shop'
  }

  const typesOfDistributor = distributor.Workshop_Partsdealer_Type__c.split(';')

  return typesOfDistributor.includes('Service 24 Partner') ? 'workshop24' : 'workshop'
}

// the IDs are the same as the dataset values set in the HTML element
const SKILL_MAP = {
  'Body Construction/Welding Certificate': 'bodyConstruction',
  'E-Mobility': 'eMobility',
  'Steering Axle Repair/Wheel Alignment': 'axleRepair',
  'Haldex Diagnosis': 'haldexDiagnosis',
} as const

/**
 * Filter skills coming from the API to just account for the ones that are allowed to be displayed
 * @returns An array containing the IDs of the skills
 * @param distributor
 */
export const getFilteredSkillIds = (distributor: Pick<DistributorItem, "Additional_Skills_Service_Partners__c" | "Workshop_Partsdealer_Type__c">) => {
  if (isInPartsDealerMode() || !distributor.Additional_Skills_Service_Partners__c) {
    return []
  }

  const skills = distributor.Additional_Skills_Service_Partners__c.split(';')
  const types = distributor.Workshop_Partsdealer_Type__c?.split(';') ?? []

  return skills
    .filter((skill: string): skill is keyof typeof SKILL_MAP => skill in SKILL_MAP)
    .map(skill => SKILL_MAP[skill])
    .filter(skillId => {
      if (skillId === 'haldexDiagnosis') {
        return types.includes('Haldex Service Partner')
      }
      return true
    })
}
